import { Form, Input } from "antd";
import { noTrailingSpaceAllowedRule } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

export const SecondaryATSIdField = ({
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <Input
      placeholder="Enter Secondary ATS ID"
      disabled={disabled}
      style={style}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Secondary ATS ID"
        name="extSecondaryAtsId"
        rules={[noTrailingSpaceAllowedRule()]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Secondary ATS ID" extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
